export const CoverReason = Object.freeze({
  SPECIFIC_TREATMENT: 'a specific treatment',
  PLANNING_A_FAMILY: 'planning a family',
  PEACE_OF_MIND: 'total peace of mind',
  BASICS: 'just the basics',
  GOOD_ALL_ROUND_COVER: 'good all round cover',
});

export default CoverReason;
